class Header {
    constructor() {
        this.header = document.querySelector('header');
        if (this.header) {
            this.checkPositionScroll();
            document.addEventListener('scroll', () => this.checkPositionScroll());
        }
    }

    checkPositionScroll() {
        if (document.documentElement.scrollTop > 0) {
            this.header.classList.remove('no-bg');
        } else {
            this.header.classList.add('no-bg');
        }
    }
}

export default Header;
